/**
 * Tab Title Switcher
 * Switches the document title when the tab is inactive (hidden).
 * Cycles through a list of emotional messages.
 * Welcomes the user back when they return.
 */

(function () {
    let originalTitle = document.title;
    let intervalId = null;
    let messageIndex = 0;

    const messages = [
        "Emotionally available tab",
        "This tab feels ignored",
        "We're trying not to overthink",
        "Where'd you go?",
        "No pressure. But hi."
    ];

    const handleVisibilityChange = () => {
        if (document.hidden) {
            // Tab is hidden (user switched tabs)
            originalTitle = document.title; // Save the current title just in case it changed

            // helper function to update title
            const updateTitle = () => {
                document.title = messages[messageIndex];
                messageIndex = (messageIndex + 1) % messages.length;
            };

            // Update immediately
            updateTitle();

            // Start cycling every 5 seconds
            intervalId = setInterval(updateTitle, 5000);

        } else {
            // Tab is visible again (user came back)
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }

            document.title = "Hey. You're back!";

            setTimeout(() => {
                document.title = originalTitle;
            }, 1500);
        }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup on page unload to prevent memory leaks
    window.addEventListener('beforeunload', () => {
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    });
})();

(function () {
    let originalTitle = document.title;
    let intervalId = null;
    let messageIndex = 0;

    const messages = [
        "Emotionally available tab 🤍",
        "This tab feels ignored 🫥",
        "We’re trying not to overthink 🌀",
        "👀 Where’d you go?",
        "No pressure. But hi. 😊"
    ];

    const handleVisibilityChange = () => {
        if (document.hidden) {
            // Tab is hidden (user switched tabs)
            originalTitle = document.title; // Save the current title just in case it changed

            // helper function to update title
            const updateTitle = () => {
                document.title = messages[messageIndex];
                messageIndex = (messageIndex + 1) % messages.length;
            };

            // Update immediately
            updateTitle();

            // Start cycling every 10 seconds
            intervalId = setInterval(updateTitle, 5000);

        } else {
            // Tab is visible again (user came back)
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }

            document.title = "Hey. You’re back ❣️";

            setTimeout(() => {
                document.title = originalTitle;
            }, 1500);
        }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
})();

